import React, { useState, useCallback, useEffect, VFC } from 'react';

import { API_V1_INSTAGRAM_IMAGES } from '../../../../routing';
import { Image } from '~/models/Instagram/InstagramModel';
import { fetchJsonData } from '../../../../../core/ajax';
import InstagramImageComponent from './components';

const MAX_IMAGE_COUNT = 9;

const defaultImage = (id: string): Image => ({
  loading: true,
  id,
  caption: '',
  mediaType: '',
  mediaUrl: '',
  thumbnailUrl: '',
  permalink: '',
  timestamp: '',
  username: '',
});

interface Props {}
// TODO ContainerパターンのcomponentsディレクトリとAtomic Designのディレクトリ設計が混在している。
// トップページはAtomic Designに統一したいので、Atomic Designのディレクトリに移動したい。
// また、APIインターフェースはcontainerコンポーネントに移動したい。
const InstagramImages: VFC<Props> = (props: Props) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const [images, setImages] = useState<Image[]>(
    [...Array(MAX_IMAGE_COUNT).keys()].map((v) => defaultImage(String(v))),
  );

  const fetchInstagramImages = useCallback(() => {
    fetchJsonData(
      `${API_V1_INSTAGRAM_IMAGES}?max_count=${MAX_IMAGE_COUNT}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      },
      ({ instagramImages }: { instagramImages: Array<any> }) => {
        if (instagramImages.length > MAX_IMAGE_COUNT) {
          setImages(
            instagramImages.filter((v, index) => MAX_IMAGE_COUNT > index),
          );
          return;
        }
        setImages(instagramImages);
      },
      (_, data) => {
        setHasError(true);
      },
    );
  }, []);

  useEffect(() => {
    fetchInstagramImages();
  }, [fetchInstagramImages]);

  return <InstagramImageComponent hasError={hasError} images={images} />;
};

export default InstagramImages;
